import React, { PureComponent } from 'react';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from 'shared/components/spinner/spinner';

import * as FormDataActions from 'bv360/redux/actions/form-data';
import * as OrderActions from 'bv360/redux/actions/orders';
import ErrorBoundary from 'shared/components/error-boundary';

import FormSelector from './form-selector';

class QuickSign extends PureComponent {
  state = {
    today: new Date(),
    qsValues: null
  };

  componentDidMount() {
    this.props.actions.getQuickSign(this.props.match.params.uuid);
    this.props.actions.getICD10s();
  }

  render() {
    const { quickSignVerified, currentOrder, quickSignDocType } = this.props;

    return (
      <ErrorBoundary>
        <Container className="content--app">
          {!quickSignVerified || !currentOrder || !quickSignDocType ? (
            <Spinner />
          ) : (
            <FormSelector
              {...this.props}
              qsValues={{
                officeZip: currentOrder.physician_office?.zip || currentOrder.physician_if_other_zip,
                uuid: this.props.match.params.uuid
              }}
              authenticated
              isRx
            />
          )}
        </Container>
      </ErrorBoundary>
    );
  }
}

QuickSign = connect(
  state => ({
    currentOrder: state.orders.currentOrder,
    quickSignDocType: state.orders.quickSignDocType,
    quickSignVerified: state.orders.quickSignVerified,
    error: state.orders.error,
    loading: state.orders.loading.includes('orders'),
    icd10s: state.icd10s,
    user: state.user.user
  }),
  dispatch => ({
    actions: {
      getICD10s: bindActionCreators(FormDataActions.getICD10s, dispatch),
      getQuickSign: bindActionCreators(OrderActions.getQuickSign, dispatch)
    }
  })
)(QuickSign);

QuickSign.propTypes = {};

export default QuickSign;
